import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';

import Panel from '../../../Panels';
import ReferenceVerification from './ReferenceVerification';

import { computeSearchesStatus } from '../lib/status';

const ProfessionalReferenceVerification = ({ searches }) =>
  !!searches.length && (
    <Panel
      title={i18n.getStr('components.professionalReferenceVerifications')}
      status={computeSearchesStatus(searches)}
    >
      <ReferenceVerification searches={searches} />
    </Panel>
  );

ProfessionalReferenceVerification.propTypes = {
  searches: PropTypes.array,
};

ProfessionalReferenceVerification.defaultProps = {
  searches: [],
};

export default i18n.renderTranslation()(ProfessionalReferenceVerification);
